<template>
    <div class="outDiv">
        <div class="searchBar">
            <div class="searchLeft">
                <el-popover placement="right-bottom" title="条件检索" trigger="click" v-model="searchVisible">
                    <searchForm @startSearch="handleTableSearch" @cancleSearch="handleCancleSeach"></searchForm>
                    <el-button slot="reference" size="mini">按条件筛选</el-button>
                </el-popover>
                <navTopTag :searchTagList="searchTagList" @handleDelOne="handleDelOne"></navTopTag>
            </div>
        </div>

        <div>
            <el-tabs v-model="allTableObj.currentTab" @tab-click="tabClick($event)">
                <el-tab-pane label="所有数据" name="all" ref="all" id="allTab"></el-tab-pane>
                <el-tab-pane label="搜索结果" name="search"></el-tab-pane>
            </el-tabs>
            <div class="tableContainer">
                <baseTable :columns="allTableObj.columns" :dataList="allTableObj.dataList" :options="allTableObj.options" :loadObj="allTableObj.loadObj" :operationColumn="allTableObj.operationColumn" :fenyeObj="allTableObj.fenyeObj" @dataSizeChange="handleSizeChange($event, allTableObj)" @dataCurrentChange="handleCurrentChange($event, allTableObj)"></baseTable>
            </div>
        </div>

    </div>
</template>
<script>
import searchForm from "./components/search-form.vue";
import dataApi from "./_api/api";
import { request } from "https";
import { mapState } from "vuex"
import { getOlderList, getOlderAccountStasticApi } from "@/services/all-api.js"
export default {
    components: {
        searchForm
    },
    computed: {
        ...mapState(['currentSearchForm'])
    },
    data() {
        return {

            searchTagList: [],

            searchVisible: false,
            allTableObj: {
                columns: [
                    {
                        prop: "num",
                        label: "#",
                        width: "100px",
                        align: "center"
                    },
                    {
                        prop: "theOldName",
                        label: "老人姓名",
                        align: "center",
                        // route: true,
                        // method: (index, row) => {
                        //     this.goOneOld(index, row);
                        // }
                    },

                    {
                        prop: "community",
                        label: "所属社区",
                        align: "center"
                    },
                    {
                        prop: "createTime",
                        label: "创建时间",
                        align: "center"
                    },
                    {
                        prop: "status",
                        label: "审批状态",
                        align: "center",
                        render: (h, params) => {
                            return h(
                                "span",
                                {},
                                params.row.status === 0
                                    ? "审批中"
                                    : params.row.status === 1
                                        ? "通过"
                                        : params.row.status === 2
                                            ? "不通过"
                                            : ""
                            );
                        }
                    }

                ],
                dataList: [],
                options: {
                    stripe: true,
                    highlightCurrentRow: true,
                    headStyleMethod: this.getTableHead
                },
                loadObj: {
                    isLoading: false
                },
                allDataNow: {
                    currentPage: 1,
                    pageSize: 20,
                    dataList: [],
                    // type: 1,
                    total: 0
                },
                // waitDataNow: {
                //   currentPage: 1,
                //   pageSize: 20,
                //   dataList: [],
                //   type: 1,
                //   total: 0
                // },
                searchDataNow: {
                    currentPage: 1,
                    pageSize: 20,
                    searchObj: {},
                    dataList: [],
                    total: 0
                },
                operationColumn: {
                    show: true,
                    align: "center",
                    width: "200px",
                    btns: [
                        {
                            size: "mini",
                            icon: "el-icon-tickets",
                            style: "font-size:16px",
                            type: "text",
                            disabled: false,
                            method: (index, row) => {
                                this.handleDetail(index, row);
                            }
                        }
                    ]
                },
                fenyeObj: {
                    showPage: true,
                    currentPage: 1,
                    pageSize: 20,
                    layoutString: "total,sizes,prev,pager,next,jumper",
                    total: 0
                },
                currentTab: "all",
                searchObj: {}
            }
        };
    },
    methods: {
        showSearchForm() {
            this.searchVisible = true;
        },
        handleTableSearch(i) {
            this.searchVisible = i.searchShow;
            this.searchTagList = this.getTagList(
                this.getFaceUpdateSearch(),
                i.searchData
            );
            this.$store.commit("setSearchForm", i.searchData);
            this.allTableObj.searchObj = i.searchData;
            this.allTableObj.currentTab = "search";
            const reqObj = {
                index: 0,
                size: 20,
                ...i.searchData
            };
            this.pageSearchGet(reqObj, this.allTableObj);


        },
        handleCancleSeach(i) {
            this.searchVisible = i.searchShow;
        },
        handleDelOne(i) {
            //减少一个检索条件时
            this.searchTagList = this.searchTagList.filter((item, index) => {
                if (item[0] === i[0]) {
                    return false;
                } else {
                    return true;
                }
            });
            const obj = this.deleteOneSearch(
                i[0],
                this.$store.state.currentSearchForm
            );
            if (this.$baseFunc.paramsValidate(obj)) {
                this.allTableObj.fenyeObj.showPage = false;
                this.allTableObj.searchDataNow.dataList = [];
                this.allTableObj.searchDataNow.currentPage = 1;
                this.allTableObj.searchDataNow.pageSize = 20;
                this.allTableObj.searchDataNow.total = 0;
                this.allTableObj.currentTab = "all";
                this.$nextTick(() => {
                    this.allTableObj.fenyeObj.showPage = true;
                });
                this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
                this.allTableObj.fenyeObj.currentPage = this.allTableObj.allDataNow.currentPage;
                this.allTableObj.fenyeObj.pageSize = this.allTableObj.allDataNow.pageSize;
                this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
            } else {
                const reqObj = {
                    index: 0,
                    size: 20,
                    ...obj
                };
                this.pageSearchGet(reqObj, this.allTableObj);
            }
            this.$store.commit("setSearchForm", obj);
        },
        tabClick(i) {
            if (i.name == "all") {
                this.allTableObj.fenyeObj.showPage = false;
                this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
                this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
                this.$nextTick().then(() => {
                    this.allTableObj.fenyeObj.showPage = true;
                    this.allTableObj.fenyeObj.pageSize = this.allTableObj.allDataNow.pageSize;
                    this.allTableObj.fenyeObj.currentPage = this.allTableObj.allDataNow.currentPage;
                });
            }
            // if (i.name == "wait") {
            //   this.allTableObj.fenyeObj.showPage = false;
            //   this.allTableObj.dataList = this.allTableObj.waitDataNow.dataList;
            //   this.allTableObj.fenyeObj.total = this.allTableObj.waitDataNow.total;
            //   this.$nextTick().then(() => {
            //     this.allTableObj.fenyeObj.showPage = true;
            //     this.allTableObj.fenyeObj.currentPage = this.allTableObj.waitDataNow.currentPage;
            //     this.allTableObj.fenyeObj.pageSize = this.allTableObj.waitDataNow.pageSize;
            //   });
            // }
            if (i.name == "search") {
                this.allTableObj.fenyeObj.showPage = false;
                this.allTableObj.dataList = this.allTableObj.searchDataNow.dataList;
                this.allTableObj.fenyeObj.total = this.allTableObj.searchDataNow.total;
                this.$nextTick().then(() => {
                    this.allTableObj.fenyeObj.showPage = true;
                    this.allTableObj.fenyeObj.currentPage = this.allTableObj.searchDataNow.currentPage;
                    this.allTableObj.fenyeObj.pageSize = this.allTableObj.searchDataNow.pageSize;
                });
            }
        },
        firstGetAll(obj) {
            obj.loadObj.isLoading = true;
            dataApi
                .firstGet()
                .then(res => {
                    console.log(res);
                    //先缓存
                    obj.allDataNow.dataList = res.allData.data;
                    obj.allDataNow.total = res.allData.total;
                    // obj.waitDataNow.dataList = res.waitData.data;
                    // obj.waitDataNow.total = res.waitData.total;
                    //最后赋值  默认全部
                    obj.dataList = res.allData.data;
                    obj.fenyeObj.total = res.allData.total;
                })
                .finally(() => {
                    obj.loadObj.isLoading = false;
                });
        },
        //检索条件或者分页等变化时请求数据
        pageSearchGet(reqobj, obj) {
            const flag = obj.currentTab;
            obj.loadObj.isLoading = true;
            obj.fenyeObj.showPage = false;
            dataApi
                .pageSearchGetFunc({ ...reqobj })
                .then(res => {
                    if (flag == "all") {
                        obj.allDataNow.dataList = res.data.data;
                        obj.allDataNow.total = res.data.total;
                        obj.fenyeObj.currentPage = obj.allDataNow.currentPage;
                        obj.fenyeObj.pageSize = obj.allDataNow.pageSize;
                        obj.dataList = obj.allDataNow.dataList;
                        obj.fenyeObj.total = obj.allDataNow.total;
                        return false;
                    }
                    //  else if (flag == "wait") {
                    //   obj.waitDataNow.dataList = res.data.data;
                    //   obj.waitDataNow.total = res.data.total;
                    //   obj.fenyeObj.currentPage = obj.waitDataNow.currentPage;
                    //   obj.fenyeObj.pageSize = obj.waitDataNow.pageSize;
                    //   obj.dataList = obj.waitDataNow.dataList;
                    //   obj.fenyeObj.total = obj.waitDataNow.total;
                    //   return false;
                    // }
                    else if (flag == "search") {
                        obj.searchDataNow.dataList = res.data.data;
                        obj.searchDataNow.total = res.data.total;
                        obj.fenyeObj.currentPage = obj.searchDataNow.currentPage;
                        obj.fenyeObj.pageSize = obj.searchDataNow.pageSize;
                        obj.dataList = obj.searchDataNow.dataList;
                        obj.fenyeObj.total = obj.searchDataNow.total;
                        return false;
                    }
                })
                .finally(() => {
                    obj.loadObj.isLoading = false;
                    obj.fenyeObj.showPage = true;
                });
        },
        //每次页面码数变了 要变回第一页
        handleSizeChange(i, obj) {
            let reqObj = {};
            if (obj.currentTab == "all") {
                obj.allDataNow.currentPage = 1;
                obj.allDataNow.pageSize = i;
                reqObj = {
                    index: 0,
                    size: i
                    // type: 3
                };
            }
            //  else if (obj.currentTab == "wait") {
            //   obj.waitDataNow.currentPage = 1;
            //   obj.waitDataNow.pageSize = i;
            //   reqObj = {
            //     index: 0,
            //     size: i,
            //     type: 3,
            //     status: 0
            //   };
            // }
            else if (obj.currentTab == "search") {
                obj.searchDataNow.currentPage = 1;
                obj.searchDataNow.pageSize = i;
                reqObj = {
                    index: 0,
                    size: i,
                    // type: 3,
                    ...this.currentSearchForm,
                    starttime: this.currentSearchForm.timeRange
                        ? this.currentSearchForm.timeRange[0]
                        : "",
                    endtime: this.currentSearchForm.timeRange
                        ? this.currentSearchForm.timeRange[1]
                        : ""
                };
            }
            this.pageSearchGet(reqObj, this.allTableObj);
        },
        handleCurrentChange(i, obj) {
            let reqObj = {};
            let flag = obj.currentTab;
            if (flag == "all") {
                obj.allDataNow.currentPage = i;
                obj.allDataNow.pageSize = obj.allDataNow.pageSize;
                reqObj = {
                    index: i - 1,
                    // type: 3,
                    size: obj.allDataNow.pageSize
                };
            }
            //  else if (flag == "wait") {
            //   obj.waitDataNow.currentPage = i;
            //   obj.waitDataNow.pageSize = obj.waitDataNow.pageSize;
            //   reqObj = {
            //     index: i - 1,
            //     type: 3,
            //     size: obj.waitDataNow.pageSize,
            //     status: 0
            //   };
            // }
            else if (flag == "search") {
                obj.searchDataNow.currentPage = i;
                obj.searchDataNow.pageSize = obj.searchDataNow.pageSize;
                reqObj = {
                    index: i - 1,
                    size: obj.searchDataNow.pageSize,
                    // type: 3,
                    ...this.currentSearchForm,
                    starttime: this.currentSearchForm.timeRange
                        ? this.currentSearchForm.timeRange[0]
                        : "",
                    endtime: this.currentSearchForm.timeRange
                        ? this.currentSearchForm.timeRange[1]
                        : ""
                };
            }
            this.pageSearchGet(reqObj, this.allTableObj);
        },
        goOneOld(i, j) {
            this.$router.push({
                path: "olderList/detail"
            });
            const temp = {
                theOldGid: j.gid,
                theOldName: j.olderName,
                status: j.status,
                theOldPhone: j.phone
            };
            this.$store.commit("SET_ONEOLDER", temp);
        },


        handleDetail(i, j) {
            this.$router.push({
                path: "approveFaceList/detail"
            });
            console.log(j);
            sessionStorage.setItem("faceUpdateGid", j.gid)

        }
    },
    mounted() {
        this.firstGetAll(this.allTableObj);
    }
};
</script>
<style lang="scss" scoped>
.outDiv {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #ebeef5;
    padding: 20px;
    display: flex;
    flex-flow: column;
}

.searchBar {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    .searchLeft {
        display: flex;
        flex-flow: row;
        justify-content: center;
    }
}

.tableContainer>div {
    height: calc(100vh - 410px);
}
</style>

